// extracted by mini-css-extract-plugin
export default {"inputWrapper":"NumberInput_inputWrapper__y72YX"};